import {
    Box,
    Button,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import Icon1 from '../../assets/repayment-channel/repayment-channel-icon1.png'
import Icon2 from '../../assets/repayment-channel/repayment-channel-icon2.png'
import Icon3 from '../../assets/repayment-channel/repayment-channel-icon3.png'
import Icon4 from '../../assets/repayment-channel/repayment-channel-icon4.png'
import Icon5 from '../../assets/repayment-channel/repayment-channel-icon5.png'
import Icon6 from '../../assets/repayment-channel/repayment-channel-icon6.png'
import Icon7 from '../../assets/repayment-channel/repayment-channel-icon7.png'
import Icon8 from '../../assets/repayment-channel/repayment-channel-icon8.png'
import Icon9 from '../../assets/repayment-channel/repayment-channel-icon9.png'
import Icon10 from '../../assets/repayment-channel/repayment-channel-icon10.png'
import IconPay from '../../assets/repayment-channel/pay.png'

import { ROOT_PATH, App_Language_key } from '../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppRepaymentChannel: React.FC = () => {
    const { t } = useTranslation()

    // 打开新页面
    const openNewPage = (path: String) => {
        window.open(ROOT_PATH + path)
    }
    
    const data = [
        {
            'icon': Icon10,
            'title': t('t3011'),
            'data': [
                t('t3012'),
                
            ],
            'subtitle': t('t3013'),
            'buttonTitle': t('t3014'),
            'path': '/find-agreement-number',
        },
        {
            'icon': Icon1,
            'title': t('t302'),
            'data': [
                t('t303'),
                t('t304'),
                t('t305'),
                t('t306'),
            ],
            'special': t('t3061'),
            'data2': t('t307'),
            'content': t('t308'),
            'buttonTitle': '',
        },
        {
            'icon': Icon2,
            'title': t('t309'),
            'data': [
                t('t310'),
                t('t311'),
                t('t312'),
                t('t313'),
                t('t314'),
                t('t315'),
                t('t316'),
                t('t317'),
                t('t318'),
                t('t319'),
            ],
            'content': t('t320'),
            'tips': '',
            'buttonTitle': t('t321'),
            'path': '/find-bank-account',
        },
        {
            'icon': Icon3,
            'title': t('t322'),
            'data': [
                t('t323'),
                t('t324'),
                t('t325'),
                t('t326'),
                t('t327'),
                t('t328'),
            ],
            'content': t('t329'),
            'tips': '',
            'buttonTitle': t('t330'),
            'path': '/find-bank-account',
        },
        {
            'icon': Icon4,
            'title': t('t331'),
            'data': [
                t('t332'),
                t('t333'),
                t('t334'),
                t('t335'),
                t('t336'),
                t('t337'),
                t('t338'),
                t('t339'),
            ],
            'content': t('t340'),
            'tips': '',
            'buttonTitle': t('t341'),
            'path': '/find-bank-account',
        },
        {
            'icon': Icon5,
            'title': t('t342'),
            'data': [
                t('t343'),
                t('t344'),
                t('t345'),
                t('t346'),
            ],
            'content': t('t347'),
            'tips': '',
            'buttonTitle': '',
        },
        {
            'icon': Icon6,
            'title': t('t348'),
            'data': [
                'icon',
                t('t349'),
                t('t350'),
                t('t351'),
                t('t352'),
                t('t353'),
            ],
            'content': '',
            'tips': t('t354'),
            'buttonTitle': t('t3541'),
            'path': '/find-merchant',
        },
        {
            'icon': Icon7,
            'title': t('t355'),
            'data': [
                t('t356'),
                t('t357'),
                t('t358'),
                t('t359'),
                t('t360'),
                t('t361'),
                t('t362'),
            ],
            'content': t('t363'),
            'tips': '',
            'buttonTitle': '',

        },
        {
            'icon': Icon8,
            'title': t('t364'),
            'data': [
                t('t365') + '\n\n',
                t('t3651'),
                t('t3652'),
                t('t3653'),
                t('t3654'),
                t('t3655'),
                t('t3656') + '\n\n',
                t('t366'),
                t('t367'),
                t('t368'),
                t('t369') + '\n\n',
                t('t3691'),
                t('t3692'),
            ],
            'content': t('t370'),
            'tips': '',
            'buttonTitle': '',
        },
        {
            'icon': Icon9,
            'title': t('t371'),
            'data': [
                t('t372'),
                t('t373'),
                t('t374'),
                t('t375'),
                t('t376'),
                t('t377'),
            ],
            'content': '',
            'tips': '',
            'buttonTitle': t('t378'),
            'path': '/one-click-pay',
        },
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '30px',
                paddingBottom: '30px',
                alignItems: 'start',
                justifyContent: 'start'
            }}>
                <Image src={data[index]['icon']} style={{objectFit: 'cover', borderRadius: '10px'}} alt='' preview={false}></Image>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '8px',
                    paddingRight: '8px',
                    alignContent: 'start',
                    justifyContent: 'start'
                }}>
                    <Typography fontSize={24} fontWeight={700} color={'#141F39'} paddingTop={'20px'} paddingBottom={'12px'}>
                        {data[index]['title']}
                    </Typography>
                    <Typography fontSize={18} fontWeight={600} color={'#141F39'} paddingBottom={'10px'}>
                        {data[index]['subtitle']}
                    </Typography>
                    {data[index]['data'].map((value: string, subIndex: number) => (
                        renderTitleItem(value, subIndex)
                    ))}
                    {data[index]['special'] !== '' ? (<Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={sessionStorage.getItem(App_Language_key) === 'ms' ? '88px' : '51px'}>
                        {data[index]['special']}
                    </Typography>) : (<Box></Box>)
                    }
                    {data[index]['data2'] !== '' ? (<Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} >
                        {data[index]['data2']}
                    </Typography>) : (<Box></Box>)
                    }
                    {data[index]['content'] !== '' ? (<Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'24px'}>
                        {data[index]['content']}
                    </Typography>) : (<Box></Box>)
                    }
                    {data[index]['tips'] !== '' ? (<Typography fontSize={16} fontWeight={600} color={'red'} paddingTop={'24px'}>
                        {data[index]['tips']}
                    </Typography>) : (<Box></Box>)
                    }

                    {
                        data[index]['buttonTitle'] !== '' ? (<Box sx={{paddingTop: '40px'}}>
                            <Button
                                onClick={()=>{openNewPage(data[index]['path'])}}
                                sx={{
                                    borderRadius: '30px',
                                    height: '60px',
                                    paddingLeft: '24px',
                                    paddingRight: '24px',
                                    bgcolor: '#FFC107',
                                    border: '1px solid #FFC107',
                                    color: '#141F39',
                                    textTransform: 'none',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                }}
                            >
                                {data[index]['buttonTitle']}
                            </Button>
                        </Box>) : (<Box></Box>)
                    }
                </Box>
            </Box>
        )
    }

    // url可点击且文字改为主体色
    const TextWithLinks = ({ text }) => {
        // 使用正则表达式分割文本为普通文本和URL
        const urlRegex = /(https?:\/\/[^\s]+)/g
        const parts = text.split(urlRegex)
      
        return (
          <div>
            {parts.map((part, index) => {
              // 奇数索引的元素是URL
              if (index % 2 === 1) {
                return (
                  <a
                    key={index}
                    href={part}
                    style={{ 
                      color: '#FFC107',
                    //   textDecoration: 'underline',
                      cursor: 'pointer'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {part}
                  </a>
                )
              }
              // 普通文本直接返回
              return part
            })}
          </div>
        )
    }

    const renderTitleItem = (value: string, index: number) => {
        return value === 'icon' ? (<div style={{ display: 'flex', alignItems: 'center', fontSize: '16px', color: '#6B6B6B' }}>
            <span>{t('t3491')}</span>
            <img src={IconPay} alt="icon" style={{ width: 20, height: 20, margin: '0 8px' }} />
            <span>{t('t3492')}</span>
            </div>) : (
            <Typography key={index} fontSize={16} fontWeight={400} color={'#6B6B6B'} 
              sx={{
                whiteSpace: 'pre-wrap', // 必须保留，识别换行
                margin: 0,  // 👈 全局：默认完全没有间距！
                padding: 0,
              }}>
                <TextWithLinks text={value} />
            </Typography>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFDF7',
            paddingTop: '45px',
        }}>
            {data.map((item, index) => (
                renderItem(index)
            ))}
        </Box>
    )
}

// ======================= EXPORT
export default SMAppRepaymentChannel
